/**
 * Axios instance for the shared backend (sync / cloud persistence).
 *
 * Separate from the main MarketView API instance so that:
 * - Desktop can continue to hit `web.eunosoft.com/api` for auth/market data
 * - All platforms can hit the shared backend for chart/settings/watchlist sync
 *
 * The base URL is read from `REACT_APP_SYNC_URL` (defaults to the MarketView URL
 * if not set, allowing a single-server deployment).
 */
import axios from "axios";
import { getAccessToken } from "@service/local-storage-handler";

const syncApi = axios.create({
  baseURL: process.env.REACT_APP_SYNC_URL || process.env.REACT_APP_MARKETVIEW_URL,
  timeout: 10000,
});

// Inject Bearer token on every sync request
syncApi.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
});

export default syncApi;
